import {
  arrayBufferDownload,
  arrayBufferDownloadExcel,
  downloadCSV,
} from "../../../../utils/download";
import {
  decorateEmptyGridValues,
  setColumnDefaultExtraProps,
} from "../../../../utils/table/gridUtils";
import { UPLOAD_IMAGE } from "../../../types/uploadimage.type";
import {
  FETCH_SETTINGS_SETTINGWEEKENDS_LIST,
  TOAST,
  FETCH_SETTINGS_SETTINGWEEKENDS_INIT,
  FETCH_SETTINGS_SETTINGWEEKENDS_DETAIL,
  EXPORT_SETTINGS_SETTINGWEEKENDS,
  CREATE_SETTINGS_SETTINGWEEKENDS,
  EDIT_SETTINGS_SETTINGWEEKENDS,
  INIT_CREATE_SETTINGS_SETTINGWEEKENDS_SCREEN,
  SETTINGS_SETTINGWEEKENDSDD,
  SETTINGS_SETTINGWEEKENDSDELETE,
  SET_DELETE_CONFIRMATION_POPUP_VISIBILITY,
  SETTINGS_SETTINGWEEKENDS_SAVE_TABLE_STATE,
} from "../../../types/Settings/SettingWeekends.type";
import { formatDatesMmDdYyyy } from "../../../../utils";

const formFieldValueMap = {
  id: null,
  endDate: "",
  startDate: "",
  modBy: "",
  modTime: "",
  status: 1,
  weekendDays: "",
  userId: "",
};

const INITIAL_STATE = {
  SettingsSettingWeekendsListview: [],
  SettingWeekendsDD: [],
  isSettingsSettingWeekendsDDSuccess: false,
  isSettingsSettingWeekendsDDError: false,
  isLoading: false,
  error: null,
  formFieldValueMap,
  isSettingsSettingWeekendsCreateSuccess: false,
  isSettingsSettingWeekendsCreateError: false,
  isSettingsSettingWeekendsDetailSuccess: false,
  isSettingsSettingWeekendsDetailError: false,
  isSettingsSettingWeekendsEditSuccess: false,
  isSettingsSettingWeekendsEditError: false,
  isSettingsSettingWeekendsExportSuccess: false,
  isSettingsSettingWeekendsExportError: false,
  isUploadImageSuccess: false,
  isUploadImageError: false,
  imageUploadResponse: null,
  isSettingsSettingWeekendsDeleteSuccess: false,
  isSettingsSettingWeekendsDeleteError: false,
  savedTableState: null,
};

const tranformToGridView = (data) => {
  const rows = data.map((item) => {
    const {
      crtBy,
      crtTime,
      startDate,
      id,
      modBy,
      modTime,
      status,
      endDate,
      weekendDays,
    } = item;

    const transformedValues = {
      crtBy,
      crtTime,
      startDate,
      id,
      modBy,
      modTime,
      status,
      endDate,
      weekendDays,
    };
    const decoratedValues = {};
    Object.keys(transformedValues).forEach((key) => {
      decoratedValues[key] = decorateEmptyGridValues(transformedValues[key]);
    });
    return decoratedValues;
  });

  const columns = [
    {
      colLabel: "ID",
      dataKey: "id",
      extraProps: {
        isSortable: true,
        isDateField: false,
        shouldFilter: true,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search...",
      },
    },
    {
      colLabel: "Start Date",
      dataKey: "startDate",
      extraProps: {
        isSortable: true,
        isDateField: true,
        shouldFilter: true,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search...",
      },
    },
    {
      colLabel: "End Date",
      dataKey: "endDate",
      extraProps: {
        isSortable: true,
        isDateField: true,
        shouldFilter: true,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search...",
      },
    },
    {
      colLabel: "Weekend Days",
      dataKey: "weekendDays",
      extraProps: {
        isSortable: true,
        isDateField: false,
        shouldFilter: true,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search...",
      },
    },

    {
      colLabel: "Crt By",
      dataKey: "crtBy",
      extraProps: {
        isSortable: true,
        isDateField: false,
        shouldFilter: true,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search...",
      },
    },
    {
      colLabel: "Crt Time",
      dataKey: "crtTime",
      extraProps: {
        isSortable: true,
        isDateField: true,
        shouldFilter: true,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search...",
      },
    },
    {
      colLabel: "Mod By",
      dataKey: "modBy",
      extraProps: {
        isSortable: true,
        isDateField: false,
        shouldFilter: true,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search...",
      },
    },
    {
      colLabel: "Edit Time",
      dataKey: "modTime",
      extraProps: {
        isSortable: true,
        isDateField: true,
        shouldFilter: true,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search...",
      },
    },
    {
      colLabel: "Status",
      dataKey: "status",
      extraProps: {
        isSortable: true,
        isDateField: false,
        shouldFilter: true,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search...",
      },
    },
  ];

  return {
    datas: { columns, rows },
  };
};

export const SettingsSettingWeekendsReducer = (
  state = INITIAL_STATE,
  action
) => {
  switch (action.type) {
    case FETCH_SETTINGS_SETTINGWEEKENDS_INIT:
      return { ...INITIAL_STATE, savedTableState: state.savedTableState, isLoadingPage: true };
    case FETCH_SETTINGS_SETTINGWEEKENDS_DETAIL.START:
    case EXPORT_SETTINGS_SETTINGWEEKENDS.START:
    case UPLOAD_IMAGE.START:
    case FETCH_SETTINGS_SETTINGWEEKENDS_LIST.START:
    case CREATE_SETTINGS_SETTINGWEEKENDS.START:
    case SETTINGS_SETTINGWEEKENDSDELETE.START:
    case EDIT_SETTINGS_SETTINGWEEKENDS.START:
    case SETTINGS_SETTINGWEEKENDSDD.START:
      return { ...state, isLoading: true };

    case FETCH_SETTINGS_SETTINGWEEKENDS_LIST.SUCCESS: {
      const { page, data } = action.payload;

      let resetState = {
        SettingsSettingWeekendsListview: [],
        paginationInfo: null,
        error: null,
        isLoading: false,
        isLoadingPage: false,
        isPageLevelError: false,
        isSettingsSettingWeekendsCreateSuccess: false,
        isSettingsSettingWeekendsCreateError: false,
        savedTableState: state.savedTableState,
      };
      if (!data) {
        return resetState;
      }
      const { number, size, totalElements, totalPages } = page;
      const { datas } = tranformToGridView(data);
      return {
        ...resetState,
        SettingsSettingWeekendsListview: datas,
        paginationInfo: {
          pageSize: size,
          totalRecords: totalElements,
          totalPages: totalPages,
          pageNumber: number,
        },
      };
    }
    case FETCH_SETTINGS_SETTINGWEEKENDS_LIST.ERROR: {
      const { error } = action.payload;

      return {
        ...state,
        SettingsSettingWeekendsListview: [],
        isLoading: false,
        isLoadingPage: false,
        error,
        isPageLevelError: true,
        isSettingsSettingWeekendsDeletionSuccess: false,
        isSettingsSettingWeekendsDeletionError: false,
        shouldOpenDeleteConfirmationPopup: false,
      };
    }

    case FETCH_SETTINGS_SETTINGWEEKENDS_DETAIL.SUCCESS: {
      const temp = action.payload;
      if (action.payload && typeof action.payload === "object") {
        Object.keys(action.payload).forEach((key) => {
          if (formFieldValueMap.hasOwnProperty(key)) {
            temp[key] = action.payload[key];
            if (key === "endDate") {
              temp[key] = formatDatesMmDdYyyy(action.payload[key]);
            }
            if (key === "startDate") {
              temp[key] = formatDatesMmDdYyyy(action.payload[key]);
            }
          }
        });
      }

      return {
        ...state,
        isLoading: false,
        formFieldValueMap: temp,
        isSettingsSettingWeekendsDetailSuccess: true,
      };
    }
    case FETCH_SETTINGS_SETTINGWEEKENDS_DETAIL.ERROR: {
      const { error } = action.payload;

      return {
        ...state,
        error,
        isSettingsSettingWeekendsDetailSuccess: false,
        isSettingsSettingWeekendsDetailError: true,
      };
    }

    //DD
    case SETTINGS_SETTINGWEEKENDSDD.SUCCESS: {
      const temp = action.payload;

      return {
        ...state,
        isLoading: false,
        SettingWeekendsDD: temp,
        isSettingsSettingWeekendsDDSuccess: true,
        isSettingsSettingWeekendsDDError: false,
      };
    }
    case SETTINGS_SETTINGWEEKENDSDD.ERROR: {
      const { error } = action.payload;

      return {
        ...state,
        error,
        isSettingsSettingWeekendsDDSuccess: false,
        isSettingsSettingWeekendsDDError: true,
      };
    }
    //END DD
    //DELETE

    case SET_DELETE_CONFIRMATION_POPUP_VISIBILITY: {
      const shouldOpenDeleteConfirmationPopup = action.payload;
      return {
        ...state,
        shouldOpenDeleteConfirmationPopup,
        isSettingsSettingWeekendsDeleteSuccess: false,
        isSettingsSettingWeekendsDeleteError: false,
      };
    }
    case SETTINGS_SETTINGWEEKENDSDELETE.SUCCESS: {
      const temp = action.payload;

      return {
        ...state,
        isLoading: false,
        isSettingsSettingWeekendsDeleteSuccess: true,
        isSettingsSettingWeekendsDeleteError: false,
        shouldOpenDeleteConfirmationPopup: false,
      };
    }
    case SETTINGS_SETTINGWEEKENDSDELETE.ERROR: {
      const { error } = action.payload;

      return {
        ...state,
        error,
        isSettingsSettingWeekendsDeleteSuccess: false,
        isSettingsSettingWeekendsDeleteError: true,
        shouldOpenDeleteConfirmationPopup: false,
      };
    }
    //END DD

    // UPLOAD_IMAGE Start
    case UPLOAD_IMAGE.ERROR: {
      const { error } = action.payload;

      return {
        ...state,
        isLoading: false,
        isLoadingPage: false,
        error,
        isUploadImageSuccess: false,
        isUploadImageError: true,
        shouldOpenExportConfirmationPopup: false,
      };
    }

    case UPLOAD_IMAGE.SUCCESS: {
      const { data } = action.payload;
      return {
        ...state,
        imageUploadResponse: data,
        isUploadImageSuccess: true,
        isUploadImageError: false,
        shouldOpenExportConfirmationPopup: false,
      };
    }

    // UPLOAD_IMAGE End

    // Export Start
    case EXPORT_SETTINGS_SETTINGWEEKENDS.ERROR: {
      const { error } = action.payload;

      return {
        ...state,
        isLoading: false,
        isLoadingPage: false,
        error,
        isSettingsSettingWeekendsExportSuccess: false,
        isSettingsSettingWeekendsExportError: true,
        shouldOpenExportConfirmationPopup: false,
      };
    }

    case EXPORT_SETTINGS_SETTINGWEEKENDS.SUCCESS: {
      const data = action.payload;
      arrayBufferDownloadExcel(data, "setting-weekends.xls");
      return {
        ...state,
        isSettingsSettingWeekendsExportSuccess: true,
        isSettingsSettingWeekendsExportError: false,
        shouldOpenExportConfirmationPopup: false,
      };
    }

    // Export End

    // EDIT
    case EDIT_SETTINGS_SETTINGWEEKENDS.ERROR: {
      const { error } = action.payload;
      return {
        ...state,
        error,
        isLoading: false,
        isSettingsSettingWeekendsEditSuccess: false,
        isSettingsSettingWeekendsEditError: true,
      };
    }

    case EDIT_SETTINGS_SETTINGWEEKENDS.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        isSettingsSettingWeekendsEditSuccess: true,
        isSettingsSettingWeekendsEditError: false,
      };
    }

    // EDIT END

    // Create
    case INIT_CREATE_SETTINGS_SETTINGWEEKENDS_SCREEN: {
      return { ...INITIAL_STATE, savedTableState: state.savedTableState };
    }

    case CREATE_SETTINGS_SETTINGWEEKENDS.ERROR: {
      const { error } = action.payload;
      return {
        ...state,
        error,
        isLoading: false,
        isSettingsSettingWeekendsCreateSuccess: false,
        isSettingsSettingWeekendsCreateError: true,
      };
    }
    case CREATE_SETTINGS_SETTINGWEEKENDS.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        isSettingsSettingWeekendsCreateSuccess: true,
        isSettingsSettingWeekendsCreateError: false,
      };
    }

    //End

    case TOAST.RESET: {
      return {
        ...state,
        isSettingsSettingWeekendsCreateSuccess: false,
        isSettingsSettingWeekendsCreateError: false,
        isSettingsSettingWeekendsEditError: false,
        isSettingsSettingWeekendsEditSuccess: false,
        isSettingsSettingWeekendsDetailError: false,
      };
    }
    case SETTINGS_SETTINGWEEKENDS_SAVE_TABLE_STATE: {
      return {
        ...state,
        savedTableState: action.payload,
      };
    }
    default:
      return state;
  }
};
